import { useEffect } from 'react';
import { APP_NAME } from '../../shared/constants.ts';

/** The browser-tab title for a page: "<page> · Project Map", or the app alone. */
export function documentTitle(page: string | undefined): string {
  return page === undefined || page === '' ? APP_NAME : `${page} · ${APP_NAME}`;
}

/**
 * Sets the document title while the page is shown. Pass `undefined` until
 * the page knows its own name (a node page waiting on its query), so the
 * tab reads as the app rather than a stale previous page.
 */
export function useDocumentTitle(page: string | undefined): void {
  useEffect(() => {
    document.title = documentTitle(page);
  }, [page]);
}
